<template>
  <div style="height:100%">
    <TableMain ref="OrderForecastTable1" name="myName" :fields="fields" :title="table_title.title1"
      :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_date_picker="true"
      :show_toolbar="false" :show_filter="true" :selectable="true"
      :hb_table_class="'hb_table_guest_vend_forecast_class1'" :isBusy="isBusy_table1" :table_height_adjust="-10"
      :loading_width="100" @on_query="on_query" @tool_invoke="tool_invoke" @current_changed="current_changed">
      <template #query>
        {{ $t("common.label_forecast_order_num") }}：<el-input size="small" style="width: 120px" clearable
          v-model="ForcasetId"></el-input>
      </template>
      <template #toolbar>
        <el-checkbox :label="$t('common.only_uncancel')" v-model="onlyNotCancel" class="ml-2"
          @change="notCancel"></el-checkbox>
      </template>
    </TableMain>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import * as api from "@/shared/api"
import * as localStorageMgr from "../../shared/localStorageMgr"
import TableMain from "../components/table/TableMain"
import BaseContainer from "../components/BaseContainer"
import SplitContainer2 from "../components/container/SplitContainer2"
import { Split } from "view-design"
import "view-design/dist/styles/iview.css"
import * as GuestController from "../../controllers/pages/GuestController"

export default {
  name: "GuestVendForcasetOrder",
  components: {
    TableMain,
    BaseContainer,
    Split,
    SplitContainer2,
  },
  data() {
    return {
      guest_info: null,
      tab_index: 0,
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_forecast",
      },
      ForcasetId: "",
      InventCode: "",
      fields: GuestController.fields.sf_default,
      isBusy_table1: false,
      onlyNotCancel: false,
      his_order_list: []
    }
  },
  created() {
    this.guest_info = JSON.parse(this.ls.get(localStorageMgr.data.guest_info))
  },

  methods: {
    //#region table1
    ///查询
    async on_query(set_data, date_range) {
      this.isBusy_table1 = true
      set_data([])
      this.his_order_list = []
      let _fromDate = "",
        _toDate = ""
      let _params = {
        pub_token: this.ls.get("pub_guest_token"),
        ForcasetId: this.ForcasetId,
      }
      if (!_.isNull(date_range) && this.ForcasetId == "") {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        _params["fromDate"] = _fromDate
        _params["toDate"] = _toDate
      }
      let _result = await api.query_async({
        url: api.pub_url("get", this.guest_info.idx, "pub_get_vend_forecast_dispatch"),
        parameters: _params,
        method: "get",
      })

      if (
        _result &&
        _result[0] &&
        _result[0].result &&
        _result[0].result.data &&
        _result[0].result.data.Result &&
        _result[0].result.data.Result[0]
      ) {
        this.his_order_list = _result[0].result.data.Result[0]
        set_data(_result[0].result.data.Result[0])
      }

      this.isBusy_table1 = false
    },

    tool_invoke(data) { },
    async current_changed(old, current) {

    },
    notCancel() {
      if (this.his_order_list.length == 0) {
        this.onlyNotCancel = false
        this.msgToasts(this.$t("notify.excute_search_before"), "info")
        return
      }
      if (this.onlyNotCancel) {
        let _list = _.filter(this.$refs.OrderForecastTable1.my_data, { is_cancel: false })
        this.$refs.OrderForecastTable1.SetData(_list)
      }
      else {
        this.$refs.OrderForecastTable1.SetData(this.his_order_list)
      }
    }
  },
}
</script>

<style>
.hb_table_guest_vend_forecast_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 100rem;
}
</style>

<style scoped>
.one_table>>>.hb_table_query_container_one_table {
  background-color: white;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_thead>.hb_thead_tr>.b-table-sticky-column.hb_thead_th_name {
  left: 21px;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_tbody>.hb_tbody_tr>.b-table-sticky-column.hb_tbody_td_name {
  left: 21px;
}
</style>
